import { inject, Injectable } from '@angular/core';
import { IWidgetPermissions, PluginInjectorApplicationPlugin, PluginInjectorService } from 'core-client/api';
import {
  AhoyrtcVideoWidgetAddComponent
} from './ahoyrtc-video/ahoyrtc-video-widget-add/ahoyrtc-video-widget-add.component';
import {
  AhoyrtcVideoWidgetViewComponent
} from './ahoyrtc-video/ahoyrtc-video-widget-view/ahoyrtc-video-widget-view.component';
import {
  AhoyrtcVideoWidgetSettingsComponent
} from './ahoyrtc-video/ahoyrtc-video-widget-settings/ahoyrtc-video-widget-settings.component';


@Injectable({
  providedIn: 'root'
})
export class StreamingService {
  private readonly pluginInjector: PluginInjectorService = inject(PluginInjectorService);

  private readonly plugin: PluginInjectorApplicationPlugin.IApplicationPlugin = <PluginInjectorApplicationPlugin.IApplicationPlugin>{};
  private readonly pluginName: string = 'Streaming';
  private readonly moduleName: string = 'ahoyrtc_video';
  private widgetPermissions: IWidgetPermissions = {
    ahoyrtc_video: {
      streaming_ahoyrtc_video_enabled: false,
      streaming_ahoyrtc_video_widget_header_display: false,
      streaming_ahoyrtc_video_settings_edit: false
    }
  };

  readonly pluginModule: PluginInjectorApplicationPlugin.IPluginModule = {
    widgets: [{
      pluginModule: this.moduleName.toUpperCase(),
      pluginId: '',
      widgetPermissions: {
        widgetEnabledPermission: {
          permissionRef: 'streaming_ahoyrtc_video_enabled'
        },
        widgetBasePermissions: {
          widgetSettingsEnabledPermission: {
            permissionRef: 'streaming_ahoyrtc_video_settings_edit'
          },
          autorizeDisplayOfWidgetHeader: {
            permissionRef: 'streaming_ahoyrtc_video_widget_header_display'
          }
        }
      },
      addComponent: {
        title: '#TRANSLATE-LATER#STREAMING.AHOY_VIDEO.WIDGET.TITLE',
        componentName: 'AhoyrtcVideoWidgetAddComponent',
        component: AhoyrtcVideoWidgetAddComponent,
      },
      viewComponent: {
        title: 'VIDEO',
        componentName: 'AhoyrtcVideoWidgetViewComponent',
        component: AhoyrtcVideoWidgetViewComponent,
      },
      settingComponent: {
        componentName: 'AhoyrtcVideoWidgetSettingsComponent',
        component: AhoyrtcVideoWidgetSettingsComponent,
        dialogConfig: {
          width: this.pluginInjector.getMenuDialogConfig().width
        }
      }
    }]
  }

  async setup(): Promise<void> {
    this.initPlugin();
  }

  private initPlugin(): void {
    this.plugin.name = this.pluginName.toUpperCase();
    this.plugin.enabled = false;
    this.plugin.description = `${this.pluginName} Plugin`;
    this.plugin.permissions = {
      widget_permissions: this.widgetPermissions
    };
    this.plugin.settings = { url: '' , api_key: '' };
    this.plugin.modules = [this.pluginModule];
    this.plugin.version = '0.0.1';

    this.pluginInjector.register(this.plugin);
  }
}
